var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('cookie-law',{attrs:{"button-text":_vm.$t('buttons.accept'),"theme":"base sma"}},[_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n      "+_vm._s(_vm.$t('labels.footer'))+"\n      ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b23091bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageFooter.vue
// module id = null
// module chunks = 